export default () => {
  return (
    <div className="frp-container">
      <div className="frp-content-wrapper">

        <div className="frp-steps-container">
          <div className="frp-step-card">
            <div className="frp-step-number">1</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">下載及註冊</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">3個月手機版港股LV1串流報價</li>
                <li className="frp-reward-item">
                  3個月手機版美股LV1 (非專業版) 串流報價
                </li>
              </ul>
            </div>
          </div>

          <div className="frp-step-card">
            <div className="frp-step-number">2</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">開戶</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">HK$100超市禮券</li>
              </ul>
            </div>
          </div>

          <div className="frp-step-card">
            <div className="frp-step-number">3</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">存款HK$10,000或以上</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">HK$200超市禮券</li>
                <li className="frp-reward-item">HK$300電子佣金券</li>
              </ul>
            </div>
          </div>

          <div className="frp-step-card">
            <div className="frp-step-number">4</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">港股</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">3個月免佣 (無平台費)</li>
                <li className="frp-reward-item">
                  開戶攜行家單據，佣金再有 8 折
                </li>
              </ul>
            </div>
          </div>

          <div className="frp-step-card">
            <div className="frp-step-number">5</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">美股</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">首3個月免佣 (無平台費)</li>
                <li className="frp-reward-item">孖展利率4.8%</li>
              </ul>
            </div>
          </div>

          <div className="frp-step-card">
            <div className="frp-step-number">6</div>
            <div className="frp-step-content">
              <h2 className="frp-step-title">期貨期權</h2>
              <ul className="frp-reward-list">
                <li className="frp-reward-item">
                  首2個月買賣50款指定產品，首100張免佣
                </li>
                <li className="frp-reward-item">
                  首2個月總交易張數達400或以上，下一個月200張免佣
                </li>
                <li className="frp-reward-item">
                  開戶攜行家單據，佣金再有 8 折
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="frp-action-container">
          <button className="frp-secondary-button" onClick={() => {
            window.open('https://www.ffg.com.hk/New_Client_list', '_blank');
          }}>活動詳情</button>
        </div>
      </div>
    </div>
  );
};
